import React from "react";
import "./style.css";

const PerformanceCard = ({ signClass, cardClass, percentage, text }) => {
  return (
    <div className={`${cardClass} performanceTextCards`}>
      <div class={signClass}></div>
      <span>{text} :</span>
      <span>{percentage}</span>
    </div>
  );
};

export default PerformanceCard;
